/**
 * Builds the intake form's duplicate-check query (F14).
 *
 * Kept out of the page component so it can be unit-tested directly and so the
 * page file exports only a component (React Fast Refresh).
 *
 * A name of one or two characters matches half the table on trigram similarity
 * and is noise, so the check waits until there is enough to be meaningful; a
 * website is a strong signal the moment it is present. Returns null when there
 * is nothing worth checking, which disables the query rather than sending an
 * empty request.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 9.4, PRD F14
 */

/** Minimum name length before a duplicate check is worth firing. */
export const MIN_NAME_FOR_CHECK = 3;

export function buildDuplicateQuery(
  name: string | undefined,
  website: string | undefined,
): { name?: string; website?: string } | null {
  const trimmedName = (name ?? '').trim();
  const trimmedWebsite = (website ?? '').trim();

  const query: { name?: string; website?: string } = {};
  if (trimmedName.length >= MIN_NAME_FOR_CHECK) query.name = trimmedName;
  if (trimmedWebsite.length > 0) query.website = trimmedWebsite;

  return query.name === undefined && query.website === undefined ? null : query;
}
